import { render, staticRenderFns } from "./assessmentRecord.vue?vue&type=template&id=47304d32&scoped=true&"
import script from "./assessmentRecord.vue?vue&type=script&lang=ts&"
export * from "./assessmentRecord.vue?vue&type=script&lang=ts&"
import style0 from "./assessmentRecord.vue?vue&type=style&index=0&id=47304d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47304d32",
  null
  
)

export default component.exports